window.diagnostics = {
    diagnosticChecks: async () =>
    {
        // Check Blazor itself is loaded
        const blazorLoaded = typeof Blazor !== 'undefined';

        // Define the resources to check
        const resourcesToCheck = [
            { domain: 'cdn.jsdelivr.net', url: 'https://cdn.jsdelivr.net/npm/bootstrap@5.3.2/dist/css/bootstrap.min.css' },
            { domain: 'use.typekit.net', url: 'https://use.typekit.net/eev5ehm.css' },
            { domain: 'fonts.googleapis.com', url: 'https://fonts.googleapis.com/css2?family=Roboto:wght@400;700&display=swap' },
            { domain: 'fonts.gstatic.com', url: 'https://fonts.gstatic.com/s/roboto/v30/KFOmCnqEu92Fr1Mu4mxP.ttf' },
            { domain: 'cdnjs.cloudflare.com', url: 'https://cdnjs.cloudflare.com/ajax/libs/jquery/3.6.0/jquery.min.js' },
            { domain: 'www.googletagmanager.com', url: 'https://www.googletagmanager.com/gtag/js?id=G-WWD5WTEHY1' }
        ];

        // Check if resources are accessible
        const cdnChecks = {};
        for (const resource of resourcesToCheck)
        {
            cdnChecks[resource.domain] = await checkResourceLoaded(resource.url);
        }

        // Helper function to check if a resource is accessible
        async function checkResourceLoaded(url)
        {
            try
            {
                const response = await fetch(url, {
                    method: "HEAD",
                    mode: "no-cors",
                    cache: "no-store"
                });

                // With no-cors mode, we can't check response.ok
                // Just return true if no error was thrown
                return true;
            } catch (error)
            {
                console.error(`Error checking resource ${url}:`, error);
                return false;
            }
        }

        // Check specific libraries
        const libraryChecks = {
            'Chart.js': typeof Chart !== 'undefined',
            'Google Maps': typeof google !== 'undefined' && typeof google.maps !== 'undefined',
            'Bootstrap': typeof bootstrap !== 'undefined',
            'SortableJS': typeof Sortable !== 'undefined',
            'Patternomaly': typeof window.pattern !== 'undefined'
        };

        // Check if Google fonts are actually loaded
        const fontCheck = () =>
        {
            try
            {
                const testDiv = document.createElement('div');
                testDiv.style.fontFamily = 'Roboto Serif';
                testDiv.style.visibility = 'hidden';
                testDiv.textContent = 'Test Font Loading';
                document.body.appendChild(testDiv);

                const computedStyle = window.getComputedStyle(testDiv);
                const isLoaded = computedStyle.fontFamily.includes('Roboto Serif');

                document.body.removeChild(testDiv);
                return isLoaded;
            } catch (error)
            {
                return false;
            }
        };

        // Check if fonts are loaded from Google
        const googleFontsLoaded = fontCheck();

        // Gather user information
        const userInfo = {
            // Browser detection
            browser: (() =>
            {
                const ua = navigator.userAgent;
                let browser = "Unknown";

                if (ua.indexOf("Chrome") > -1 && ua.indexOf("Edg") === -1 && ua.indexOf("OPR") === -1)
                    browser = "Chrome";
                else if (ua.indexOf("Firefox") > -1)
                    browser = "Firefox";
                else if (ua.indexOf("Safari") > -1 && ua.indexOf("Chrome") === -1)
                    browser = "Safari";
                else if (ua.indexOf("Edg") > -1)
                    browser = "Edge";
                else if (ua.indexOf("OPR") > -1 || ua.indexOf("Opera") > -1)
                    browser = "Opera";
                else if (ua.indexOf("Trident") > -1)
                    browser = "Internet Explorer";

                return browser;
            })(),

            // Browser version
            browserVersion: (() =>
            {
                const ua = navigator.userAgent;
                let version = "Unknown";

                // Extract version for different browsers
                if (ua.indexOf("Chrome") > -1 && ua.indexOf("Edg") === -1 && ua.indexOf("OPR") === -1)
                {
                    version = ua.match(/Chrome\/(\d+\.\d+)/)[1];
                } else if (ua.indexOf("Firefox") > -1)
                {
                    version = ua.match(/Firefox\/(\d+\.\d+)/)[1];
                } else if (ua.indexOf("Safari") > -1 && ua.indexOf("Chrome") === -1)
                {
                    version = ua.match(/Safari\/(\d+\.\d+)/)[1];
                } else if (ua.indexOf("Edg") > -1)
                {
                    version = ua.match(/Edg\/(\d+\.\d+)/)[1];
                } else if (ua.indexOf("OPR") > -1)
                {
                    version = ua.match(/OPR\/(\d+\.\d+)/)[1];
                } else if (ua.indexOf("Trident") > -1)
                {
                    version = ua.match(/rv:(\d+\.\d+)/)[1];
                }

                return version;
            })(),

            // Rest of user info stays the same...
            os: (() =>
            {
                const ua = navigator.userAgent;
                if (ua.indexOf("Win") > -1) return "Windows";
                if (ua.indexOf("Mac") > -1) return "MacOS";
                if (ua.indexOf("Linux") > -1) return "Linux";
                if (ua.indexOf("Android") > -1) return "Android";
                if (ua.indexOf("like Mac") > -1) return "iOS";
                return "Unknown";
            })(),

            // Other user information remains unchanged
            deviceType: (() =>
            {
                const ua = navigator.userAgent;
                if (/(tablet|ipad|playbook|silk)|(android(?!.*mobi))/i.test(ua)) return "Tablet";
                if (/Mobile|Android|iP(hone|od)|IEMobile|BlackBerry|Kindle|Silk-Accelerated|(hpw|web)OS|Opera M(obi|ini)/.test(ua)) return "Mobile";
                return "Desktop";
            })(),

            screen: {
                width: window.screen.width,
                height: window.screen.height,
                colorDepth: window.screen.colorDepth,
                pixelRatio: window.devicePixelRatio || 1
            },

            viewport: {
                width: window.innerWidth,
                height: window.innerHeight
            },

            features: {
                cookies: navigator.cookieEnabled,
                localStorage: !!window.localStorage,
                sessionStorage: !!window.sessionStorage,
                webSockets: "WebSocket" in window,
                webWorkers: "Worker" in window,
                serviceWorkers: "serviceWorker" in navigator,
                indexedDB: "indexedDB" in window,
                geoLocation: "geolocation" in navigator,
                touchScreen: "ontouchstart" in window || navigator.maxTouchPoints > 0,
                webGL: (() =>
                {
                    try
                    {
                        const canvas = document.createElement("canvas");
                        return !!(window.WebGLRenderingContext &&
                            (canvas.getContext("webgl") ||
                                canvas.getContext("experimental-webgl")));
                    } catch (e)
                    {
                        return false;
                    }
                })()
            },

            connection: {
                type: navigator.connection ? navigator.connection.effectiveType : "Unknown",
                downlink: navigator.connection ? navigator.connection.downlink : "Unknown",
                rtt: navigator.connection ? navigator.connection.rtt : "Unknown",
                saveData: navigator.connection ? navigator.connection.saveData : "Unknown"
            },

            language: navigator.language || "Unknown",
            languages: navigator.languages ? Array.from(navigator.languages) : ["Unknown"],

            timezone: Intl.DateTimeFormat().resolvedOptions().timeZone || "Unknown",
            timezoneOffset: new Date().getTimezoneOffset(),
            currentTime: new Date().toLocaleString(),

            userAgent: navigator.userAgent,
        };

        const performanceData = (() =>
        {
            const [navigationEntry] = performance.getEntriesByType("navigation");
            if (navigationEntry)
            {
                return {
                    loadTime: Math.round(navigationEntry.loadEventEnd - navigationEntry.startTime),
                    memory: performance.memory
                        ? `${(performance.memory.usedJSHeapSize / 1024 / 1024).toFixed(2)} MB`
                        : "Unavailable"
                };
            }
            return {
                loadTime: 0,
                memory: "Unavailable"
            };
        })();

        const geolocation = await new Promise((resolve) =>
        {
            if (!navigator.geolocation)
            {
                console.error("Geolocation is not supported by this browser.");
                resolve({ latitude: "Unavailable", longitude: "Unavailable" });
                return;
            }

            navigator.geolocation.getCurrentPosition(
                (position) =>
                {
                    console.log("Lat", position.coords.latitude);
                    console.log("Long", position.coords.longitude);
                    resolve({
                        latitude: position.coords.latitude,
                        longitude: position.coords.longitude
                    });
                },
                (error) =>
                {
                    console.error("Geolocation error:", error.message);
                    resolve({ latitude: "Unavailable", longitude: "Unavailable" });
                },
                {
                    enableHighAccuracy: true,
                    timeout: 10000,
                    maximumAge: 0
                }
            );


        });

        return {
            blazorLoaded,
            cdnChecks,
            libraryChecks,
            googleFontsLoaded,
            userInfo,
            performanceData,
            geolocation
        };
    },
};

async function testNetworkSpeed()
{
    // Simple function to test download speed
    const testDownloadSpeed = async () =>
    {
        const startTime = new Date().getTime();
        // Test file URL (adjust to a file on your server for more accurate results)
        const url = "https://cdn.jsdelivr.net/npm/bootstrap@5.3.2/dist/css/bootstrap.min.css";

        try
        {
            const response = await fetch(url + "?r=" + Math.random(), { cache: "no-store" });
            if (!response.ok) throw new Error("Network response was not ok");

            const data = await response.blob();
            const endTime = new Date().getTime();
            const duration = (endTime - startTime) / 1000; // seconds
            const fileSizeInBits = data.size * 8;
            const speedBps = fileSizeInBits / duration;

            return {
                speedMbps: (speedBps / 1000000).toFixed(2),
                durationMs: endTime - startTime,
                fileSize: (data.size / 1024).toFixed(2) + " KB"
            };
        } catch (error)
        {
            return { error: error.message };
        }
    };

    // Test latency
    const testLatency = async () =>
    {
        const url = window.location.origin;
        const iterations = 3;
        let totalTime = 0;

        try
        {
            for (let i = 0; i < iterations; i++)
            {
                const startTime = new Date().getTime();
                const response = await fetch(url + "?r=" + Math.random(), {
                    method: "GET",
                    cache: "no-store"
                });
                console.log("url", url);
                console.log("Response Status:", response.status);
                if (!response.ok) throw new Error("Network response was not ok");
                const endTime = new Date().getTime();
                totalTime += (endTime - startTime);
            }

            return {
                averageLatencyMs: Math.round(totalTime / iterations)
            };
        } catch (error)
        {
            return { error: error.message };
        }
    };

    const downloadResult = await testDownloadSpeed();
    const latencyResult = await testLatency();

    return {
        download: downloadResult,
        latency: latencyResult
    };
}


